import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ComingSoonModalProps {
  isVisible: boolean;
}

export const ComingSoonModal: React.FC<ComingSoonModalProps> = ({ isVisible }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <>
          {/* Backdrop blur */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-md z-[9998]"
          />
          
          {/* Modal content - текст по центру с шириной 65% */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ 
              duration: 0.5,
              ease: "easeOut"
            }}
            className="fixed inset-0 flex items-center justify-center z-[9999]"
          >
            <div className="w-[65vw] flex items-center justify-center">
              <h2 className="text-3xl md:text-4xl 3xl:text-5xl 4xl:text-6xl 5xl:text-7xl font-thin tracking-tighter text-white lowercase text-center">
                Coming soon...
              </h2>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
